<template>
  <v-toolbar card color="transparent">
    <v-toolbar-side-icon>
      <v-icon class="grey--text">mdi-email-outline</v-icon>
    </v-toolbar-side-icon>
    <v-toolbar-title class="subheading grey--text">
      Email Commmunication on {{ value.entry ? 'entry' : 'exit' }}
    </v-toolbar-title>

    <v-spacer />

    <can I="edit" a="Opportunity">
      <v-menu left max-width="30vw" v-model="removing">
        <v-btn flat icon color="error" slot="activator">
          <v-icon size="18px">mdi-delete</v-icon>
        </v-btn>

        <v-card>
          <v-card-title class="headline">Are you sure?</v-card-title>
          <v-card-text>This will permanently remove the email communication behaviour.</v-card-text>
          <v-card-actions>
            <v-btn flat block @click="removing = false" color="grey">
              cancel
            </v-btn>
            <v-btn block @click="remove" color="error">
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </can>

    <can I="edit" a="Opportunity">
      <v-btn flat icon @click="previewing = true" color="secondary">
        <v-icon size="18px">mdi-eye</v-icon>
      </v-btn>
    </can>

    <can I="edit" a="Opportunity">
      <v-btn flat icon @click="editing = true">
        <v-icon size="18px">mdi-pencil</v-icon>
      </v-btn>
    </can>

    <v-dialog v-model="previewing" max-width="700">
      <v-card dark>
        <v-card-title class="headline">
          {{ behavior.configuration.subject ? behavior.configuration.subject : 'Message Preview' }}
        </v-card-title>
        <v-card-text>
          <markdown :html="false" :source="value.content" class="markdown" />
        </v-card-text>

        <v-card-actions><v-spacer />
          <v-btn flat  @click="previewing = false">
            dismiss
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <can I="edit" a="Opportunity">
      <v-dialog v-model="editing" max-width="700">
        <v-card dark>
          <v-card-title class="headline">
            Message Settings
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-text-field clearable
                label="Subject"
                v-model="behavior.configuration.subject"
                hint="Specify the subject or leave it blank for a default message"
              />

              <v-textarea outline auto-grow persistent-hint
                label="Message Body"
                v-model="behavior.content"
                hint="You can provide a message body using Markdown"
                required
              />

              <v-switch
                :label="`Send when ${behavior.entry ? 'entering' : 'leaving'} this phase`"
                v-model="behavior.entry"
              />
              <v-select
                v-if="behavior.entry === false"
                label="but only to"
                v-model="behavior.configuration.to"
                :items="[...opportunity.phases.map(p => p.name), 'Withdrawn', 'Unsuccessful']"
                clearable
              />
            </v-form>
          </v-card-text>
          <v-card-actions><v-spacer />
            <v-btn flat @click="cancel" color="grey">
              cancel
            </v-btn>
            <v-btn @click="submit" color="primary">
              {{ behavior.id ? 'Update' : 'Create' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </can>
  </v-toolbar>
</template>

<script>
// Components
import Markdown from 'vue-markdown'

// Vue Component
export default {
  components: { Markdown },
  props: {
    value: { type: Object },
  },
  data() {
    return {
      // Toggles
      editing: !this.value.id,
      previewing: false,
      removing: false,
      // Model
      behavior: Object.assign({}, this.value),
      // Validations
      valid: !!this.value.id,
    }
  },

  computed: {
    opportunity() {
      return this.$store.getters['admin/opportunities/find']()
    },
  },

  methods: {
    cancel() {
      this.editing = false
      this.$store.dispatch('admin/opportunities/fetch', this.$route.params.id)
    },
    submit() {
      if (this.behavior.id) {
        // Updating
        this.$store.dispatch('admin/opportunities/updateBehavior', this.behavior).then(() => (this.editing = false))
      } else {
        // Creating
        this.$store.dispatch('admin/opportunities/createBehavior', this.behavior).then(() => (this.editing = false))
      }
    },
    remove() {
      this.$store.dispatch('admin/opportunities/removeBehavior', this.behavior)
    },
  },
}
</script>
